<template>
  <div>
    <!-- MOVIE DETAILS DESK BANNER -->
    <section>
      <div class="container-fluid px-0">
        <div
          class="movieDetailBanner d-none d-md-block"
          :style="{
            background:
              'linear-gradient(1.01deg, rgba(0, 0, 0, 0.71) 8.89%, rgba(0, 0, 0, 0) 97.25%), linear-gradient(358.63deg, rgba(0, 0, 0, 0.71) 40.97%, rgba(0, 0, 0, 0) 97.07%), url(' +
              movieDetails.BannerImage1 +
              ')'
          }"
        >
          <!-- BACKGROUND IMAGE -->
          <a
            :href="'https://www.youtube.com/watch?v=' + movieDetails.Trailer"
            data-fancybox
            class="play-icon"
          >
            <img src="@/assets/img/svg/play-icon.svg" class="img-fluid" />
          </a>
          <div class="banner-content w-100 py-3 py-xl-4">
            <div class="d-md-flex align-items-center pl-md-5">
              <div class="movieDetails text-white mb-0 mb-lg-3">
                <p class="mTitle">{{ movieDetails.Name }}</p>
                <ul class="list-inline mInfo">
                  <li class="list-inline-item">{{ movieDetails.Lang }}</li>
                  <li class="list-inline-item">{{ movieDetails.Runtime }}</li>
                  <li class="list-inline-item">{{ movieDetails.Year }}</li>
                  <li class="list-inline-item">{{ movieDetails.Rated }}</li>
                  <!-- <li v-for="(directorName, directorKey2) in movieDetails.Directors" :key="directorKey2" class="list-inline-item">{{directorName.Name}}</li> -->
                </ul>
              </div>
            </div>

            <div class="d-flex align-items-center pl-3 pl-md-5">
              <!-- DIRECTOR LISTING IMAGES -->
              <!-- <div class="director-listing pr-2 pr-lg-4">
                <ul class="list-inline mb-0">
                  <li v-for="(director, directorKey1) in movieDetails.Directors" :key="directorKey1" class="list-inline-item">
                    <img :src="director.Image" class="img-fluid">
                  </li>
                </ul>
              </div>-->

              <!-- ACTOR LISTING IMAGES-->
              <!-- <div class="actor-listing mx-2 mx-lg-3 mx-xl-4">
                <ul class="list-inline mb-0">
                   <li v-for="(actor, actorKey) in movieDetails.Actors" :key="actorKey" class="list-inline-item">
                    <img :src="actor.Image" class="img-fluid">
                  </li>
                </ul>
              </div>-->

              <!-- IMDB RATING -->
              <div class="mr-3">
                <p class="small mb-1 text-white">IMDB</p>
                <ul class="list-inline imdb mb-0">
                  <li class="list-inline-item mx-0">
                    {{ movieDetails.IMDBRating }}
                  </li>
                  <!-- <li class="list-inline-item mx-0">/</li> -->
                  <!-- <li class="list-inline-item mx-0">10</li> -->
                </ul>
              </div>
              <!-- GENERAL RATING  -->
              <!-- <div class="mx-2 mx-lg-3 mx-xl-4">
                <p class="small mb-1 text-white">Rating</p>
                <ul class="list-inline g-rating mb-0">
                  <li class="list-inline-item mx-0">{{movieDetails.Rated}}</li>
                </ul>
              </div>-->

              <!-- FAVOURITE BUTTON -->
              <!-- <div class="mx-2 mx-lg-3 mx-xl-4">
                <router-link to="" tabindex="0">
                  <svg width="25" height="24" viewBox="0 0 25 24" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M3.03647 16.9155C2.03317 22.7061 6.21478 25.7129 11.4651 22.9797L12.4999 22.4411L13.5347 22.9797C18.7862 25.7137 22.9666 22.7046 21.9633 16.9155L21.7658 15.7749L22.6031 14.967C26.8514 10.8661 25.2531 5.99955 19.3836 5.15501L18.2264 4.98865L17.709 3.95082C15.0833 -1.31761 9.91533 -1.31627 7.29077 3.95082L6.77337 4.98865L5.61619 5.15501C-0.25453 5.99985 -1.85035 10.8672 2.39669 14.967L3.23398 15.7749L3.03647 16.9155ZM14.4435 21.2669L12.4999 20.2549L10.5563 21.2669C6.73944 23.2535 4.23242 21.4531 4.96187 17.2427L5.33386 15.0993L3.76107 13.5814C0.673638 10.6016 1.62846 7.68443 5.89731 7.07014L8.07111 6.75731L9.0429 4.80718C10.9501 0.979014 14.0472 0.976471 15.9569 4.80718L16.9287 6.75731L19.1025 7.07014C23.3677 7.68398 24.3274 10.5995 21.2387 13.5814L19.6659 15.0993L20.0367 17.2427C20.7662 21.4503 18.2616 23.2547 14.4435 21.2669Z"
                      fill="white"></path>
                  </svg>
                </router-link>
              </div>-->

              <!-- SHARE BUTTON -->
              <!-- <div class="mx-2 mx-lg-3 mx-xl-4">
                <router-link to="" tabindex="0">
                  <svg width="18" height="21" viewBox="0 0 18 21" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M18 3.9375C18 6.10907 16.2246 7.875 14.0399 7.875C12.7203 7.875 11.5438 7.23066 10.8244 6.25232L7.34389 8.49551C7.70424 9.09205 7.9202 9.78404 7.9202 10.5238C7.9202 10.8709 7.87626 11.2081 7.79088 11.5287C7.68917 11.9135 7.52972 12.2745 7.32003 12.5999L10.7515 14.8909C11.4484 13.817 12.6726 13.125 14.0399 13.125C16.2246 13.125 18 14.8909 18 17.0625C18 19.2341 16.2246 21 14.0399 21C11.8564 21 10.0798 19.2341 10.0559 17.0625C10.0559 17.0148 10.0622 16.9612 10.0672 16.9075C10.0735 16.8538 10.0798 16.8001 10.0798 16.7523L5.87988 13.9364C5.32743 14.2466 4.65569 14.4375 3.9601 14.4375C1.77539 14.4375 0 12.6716 0 10.5C0 8.32843 1.77539 6.5625 3.9601 6.5625C4.67955 6.5625 5.3764 6.7534 5.95145 7.08756L10.1037 4.41476C10.1037 4.346 10.0986 4.27166 10.0924 4.19445L10.0823 4.0616L10.0798 3.9375C10.0798 1.76593 11.8564 0 14.0399 0C16.2246 0 18 1.76593 18 3.9375ZM16.079 3.9375C16.079 2.8159 15.1674 1.90904 14.0399 1.90904C12.9111 1.90904 11.9996 2.8159 11.9996 3.9375C11.9996 5.0591 12.9111 5.96581 14.0399 5.96581C15.1674 5.96581 16.079 5.0591 16.079 3.9375ZM14.0399 15.034C15.1674 15.034 16.079 15.9409 16.079 17.0625C16.079 18.1841 15.1674 19.0908 14.0399 19.0908C12.9111 19.0908 11.9996 18.1841 11.9996 17.0625C11.9996 15.9409 12.9111 15.034 14.0399 15.034ZM1.91978 10.5C1.91978 11.6216 2.83133 12.5283 3.9601 12.5283C5.08761 12.5283 5.99916 11.6216 5.99916 10.5C5.99916 9.3784 5.08761 8.47154 3.9601 8.47154C2.83133 8.47154 1.91978 9.3784 1.91978 10.5Z"
                      fill="white"></path>
                  </svg>
                </router-link>
              </div>-->
              <!-- <div class="ml-auto btn-cos-container">
                <router-link to=""><img src="@/assets/img/svg/Create-your-own-Screening.svg" class="img-fluid cs-img">
                </router-link>
              </div>-->
            </div>
          </div>
        </div>

        <!-- MOVIE DETAILS MOBILE BANNER -->

        <div
          class="movieDetailBanner d-block d-md-none"
          :style="{
            background:
              'linear-gradient(1.01deg, rgba(0, 0, 0, 0.71) 8.89%, rgba(0, 0, 0, 0) 97.25%), linear-gradient(358.63deg, rgba(0, 0, 0, 0.71) 40.97%, rgba(0, 0, 0, 0) 97.07%), url(' +
              movieDetails.BannerImage +
              ')'
          }"
        >
          <!-- BACKGROUND IMAGE -->
          <a
            :href="'https://www.youtube.com/watch?v=' + movieDetails.Trailer"
            data-fancybox
            class="play-icon"
          >
            <img src="@/assets/img/svg/play-icon.svg" class="img-fluid" />
          </a>
          <div class="banner-content w-100 py-2 py-xl-4">
            <div
              class="d-md-flex align-items-center text-center text-md-left pl-xl-5"
            >
              <div class="movieDetails text-white mb-3">
                <p class="mTitle">{{ movieDetails.Name }}</p>
                <ul class="list-inline mInfo">
                  <li class="list-inline-item">{{ movieDetails.Lang }}</li>
                  <li class="list-inline-item">{{ movieDetails.Runtime }}</li>
                  <li class="list-inline-item">{{ movieDetails.Year }}</li>
                  <li class="list-inline-item">{{ movieDetails.Rated }}</li>
                  <!-- <li v-for="(directorName, directorKey2) in movieDetails.Directors" :key="directorKey2" class="list-inline-item">{{directorName.Name}}</li> -->
                </ul>
              </div>
            </div>

            <div
              class="d-md-flex align-items-center text-center text-md-left pl-xl-5"
            >
              <!-- DIRECTOR LISTING IMAGES -->
              <!-- <div class="director-listing pr-2 pr-lg-4">
                <ul class="list-inline mb-0">
                  <li v-for="(director, directorKey1) in movieDetails.Directors" :key="directorKey1" class="list-inline-item">
                    <img :src="director.Image" class="img-fluid">
                  </li>
                </ul>
              </div>-->

              <!-- ACTOR LISTING IMAGES-->
              <!-- <div class="actor-listing mx-2 mx-lg-3 mx-xl-4">
                <ul class="list-inline mb-0">
                   <li v-for="(actor, actorKey) in movieDetails.Actors" :key="actorKey" class="list-inline-item">
                    <img :src="actor.Image" class="img-fluid">
                  </li>
                </ul>
              </div>-->

              <!-- IMDB RATING -->
              <div class="text-center text-md-left">
                <p class="small mb-1 text-white">IMDB</p>
                <ul class="list-inline imdb mb-0">
                  <li class="list-inline-item mx-0">
                    {{ movieDetails.IMDBRating }}
                  </li>
                  <!-- <li class="list-inline-item mx-0">/</li> -->
                  <!-- <li class="list-inline-item mx-0">10</li> -->
                </ul>
              </div>
              <!-- GENERAL RATING  -->
              <!-- <div class="mx-2 mx-lg-3 mx-xl-4">
                <p class="small mb-1 text-white">Rating</p>
                <ul class="list-inline g-rating mb-0">
                  <li class="list-inline-item mx-0">{{movieDetails.Rated}}</li>
                </ul>
              </div>-->

              <!-- FAVOURITE BUTTON -->
              <!-- <div class="mx-2 mx-lg-3 mx-xl-4">
                <router-link to="" tabindex="0">
                  <svg width="25" height="24" viewBox="0 0 25 24" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M3.03647 16.9155C2.03317 22.7061 6.21478 25.7129 11.4651 22.9797L12.4999 22.4411L13.5347 22.9797C18.7862 25.7137 22.9666 22.7046 21.9633 16.9155L21.7658 15.7749L22.6031 14.967C26.8514 10.8661 25.2531 5.99955 19.3836 5.15501L18.2264 4.98865L17.709 3.95082C15.0833 -1.31761 9.91533 -1.31627 7.29077 3.95082L6.77337 4.98865L5.61619 5.15501C-0.25453 5.99985 -1.85035 10.8672 2.39669 14.967L3.23398 15.7749L3.03647 16.9155ZM14.4435 21.2669L12.4999 20.2549L10.5563 21.2669C6.73944 23.2535 4.23242 21.4531 4.96187 17.2427L5.33386 15.0993L3.76107 13.5814C0.673638 10.6016 1.62846 7.68443 5.89731 7.07014L8.07111 6.75731L9.0429 4.80718C10.9501 0.979014 14.0472 0.976471 15.9569 4.80718L16.9287 6.75731L19.1025 7.07014C23.3677 7.68398 24.3274 10.5995 21.2387 13.5814L19.6659 15.0993L20.0367 17.2427C20.7662 21.4503 18.2616 23.2547 14.4435 21.2669Z"
                      fill="white"></path>
                  </svg>
                </router-link>
              </div>-->

              <!-- SHARE BUTTON -->
              <!-- <div class="mx-2 mx-lg-3 mx-xl-4">
                <router-link to="" tabindex="0">
                  <svg width="18" height="21" viewBox="0 0 18 21" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M18 3.9375C18 6.10907 16.2246 7.875 14.0399 7.875C12.7203 7.875 11.5438 7.23066 10.8244 6.25232L7.34389 8.49551C7.70424 9.09205 7.9202 9.78404 7.9202 10.5238C7.9202 10.8709 7.87626 11.2081 7.79088 11.5287C7.68917 11.9135 7.52972 12.2745 7.32003 12.5999L10.7515 14.8909C11.4484 13.817 12.6726 13.125 14.0399 13.125C16.2246 13.125 18 14.8909 18 17.0625C18 19.2341 16.2246 21 14.0399 21C11.8564 21 10.0798 19.2341 10.0559 17.0625C10.0559 17.0148 10.0622 16.9612 10.0672 16.9075C10.0735 16.8538 10.0798 16.8001 10.0798 16.7523L5.87988 13.9364C5.32743 14.2466 4.65569 14.4375 3.9601 14.4375C1.77539 14.4375 0 12.6716 0 10.5C0 8.32843 1.77539 6.5625 3.9601 6.5625C4.67955 6.5625 5.3764 6.7534 5.95145 7.08756L10.1037 4.41476C10.1037 4.346 10.0986 4.27166 10.0924 4.19445L10.0823 4.0616L10.0798 3.9375C10.0798 1.76593 11.8564 0 14.0399 0C16.2246 0 18 1.76593 18 3.9375ZM16.079 3.9375C16.079 2.8159 15.1674 1.90904 14.0399 1.90904C12.9111 1.90904 11.9996 2.8159 11.9996 3.9375C11.9996 5.0591 12.9111 5.96581 14.0399 5.96581C15.1674 5.96581 16.079 5.0591 16.079 3.9375ZM14.0399 15.034C15.1674 15.034 16.079 15.9409 16.079 17.0625C16.079 18.1841 15.1674 19.0908 14.0399 19.0908C12.9111 19.0908 11.9996 18.1841 11.9996 17.0625C11.9996 15.9409 12.9111 15.034 14.0399 15.034ZM1.91978 10.5C1.91978 11.6216 2.83133 12.5283 3.9601 12.5283C5.08761 12.5283 5.99916 11.6216 5.99916 10.5C5.99916 9.3784 5.08761 8.47154 3.9601 8.47154C2.83133 8.47154 1.91978 9.3784 1.91978 10.5Z"
                      fill="white"></path>
                  </svg>
                </router-link>
              </div>-->
              <!-- <div class="ml-auto btn-cos-container">
                <router-link to=""><img src="@/assets/img/svg/Create-your-own-Screening.svg" class="img-fluid cs-img">
                </router-link>
              </div>-->
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="bg-light py-4 py-md-5">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-6 pl-3 pl-xl-4">
            <Slick ref="dateSlider" :options="dateTimeSlider">
              <div v-for="(singleDate, dateKey) in ShowDates" :key="dateKey">
                <div class="dtSlider-container">
                  <div
                    v-on:click="onSelectDate(singleDate)"
                    :class="{ active: selectedDate == singleDate }"
                    class="dt-box"
                  >
                    <p class="month">{{ singleDate.month }}</p>
                    <p class="date">{{ singleDate.date }}</p>
                    <p class="day">{{ singleDate.day }}</p>
                  </div>
                </div>
              </div>
            </Slick>
          </div>

          <div class="col-md-6 text-md-right movieDetails-drop mt-3 pt-md-0">
            <b-dropdown
              id="ddown-left"
              :text="'Show type: ' + selectedShowType"
              variant="default"
              class="m-2"
            >
              <b-dropdown-item v-on:click="onSelectShowType('All')"
                >All</b-dropdown-item
              >
              <b-dropdown-item v-on:click="onSelectShowType('Morning')"
                >Morning</b-dropdown-item
              >
              <b-dropdown-item v-on:click="onSelectShowType('Afternoon')"
                >Afternoon</b-dropdown-item
              >
              <b-dropdown-item v-on:click="onSelectShowType('Evening')"
                >Evening</b-dropdown-item
              >
            </b-dropdown>
            <!-- <b-dropdown id="ddown-right" right text="Filter By (Price, Show time)" variant="default" class="m-2">
              <b-dropdown-item href="#">Action</b-dropdown-item>
              <b-dropdown-item href="#">Another action</b-dropdown-item>
              <b-dropdown-item href="#">Something else here</b-dropdown-item>
            </b-dropdown>-->
          </div>
        </div>
      </div>
    </section>

    <section>
      <div
        v-if="Object.values(ShowTimes).length > 0"
        class="container-fluid my-4 my-md-5"
      >
        <!-- SECTION START -->
        <div
          class="mb-4"
          v-for="(singleCinema, cinemaKey) in CinemaList"
          :key="cinemaKey"
        >
          <div class="row">
            <div class="col-md-3 pl-3 pl-xl-5">
              <p class="mb-0 movieTheatreTitles">
                {{ singleCinema.CinemaName }}
              </p>
              <p class="movieTheatreAdd">{{ singleCinema.Address }}</p>
            </div>

            <div class="col-md-9">
              <div
                v-if="singleShowTime.length > 0"
                v-for="(singleShowTime, showtimeIndex) in ShowTimes"
                :key="showtimeIndex"
                class="movie-timing"
              >
                <div class="m-format redRightLine">
                  <span>{{ singleShowTime[0].Format }}</span>
                </div>
                <div class="timing-box">
                  <ul class="timing-box-list">
                    <router-link
                      :to="{
                        name: 'seatLayout',
                        params: {
                          movieId: MovieID,
                          categoryId: CategoryID,
                          cinemaScheduleId: CinemaTimeScheduleID
                        }
                      }"
                    >
                      <li
                        v-on:click="setCinemaTimeId(mTime)"
                        class
                        v-for="(mTime, mT) in singleShowTime"
                        :key="mT"
                        :class="{ active: selectedTime == mTime.CinemaTimings }"
                      >
                        {{ mTime.CinemaTimings }}
                      </li>
                    </router-link>
                  </ul>
                </div>
              </div>
            </div>
            <div
              style="margin-left: 50px;"
              v-if="singleShowTime.length == 0"
              v-for="(singleShowTime, showtimeIndex) in ShowTimes"
              :key="showtimeIndex"
            >
              No show time
            </div>
          </div>
          <hr class="bottomRedLine" />
        </div>
        <!-- SECTION START END-->
      </div>
      <div
        class="my-5 text-center h3"
        style="font-weight:bold"
        v-if="Object.values(ShowTimes).length == 0"
      >
        No Show Timings Found
      </div>
    </section>

    <section class="bg-light py-5 py-md-4">
      <div class="container-fluid my-md-4 storylineSection">
        <div class="row">
          <div class="col-md-6 pl-3 pl-xl-5">
            <p class="pb-2 sTitle">Storyline</p>
            <p class="sText">{{ movieDetails.StoryLine }}</p>
          </div>

          <div class="col-md-6">
            <div class="row">
              <div class="col-md-4 text-left text-md-center">
                <p class="pb-2 sTitle">Director</p>

                <ul class="list-inline sList mb-0">
                  <li
                    v-for="(director, directorKey) in movieDetails.Directors"
                    :key="directorKey"
                    class="list-inline-item text-center"
                  >
                    <img
                      :src="director.Image"
                      class="img-fluid rounded-circle"
                    />
                    <p class="mb-0 sName">{{ director.Name }}</p>
                  </li>
                </ul>
              </div>

              <div class="col-md-8">
                <p class="pb-2 sTitle">Cast</p>

                <ul class="list-inline sList mb-0">
                  <li
                    v-for="(actor, actorKey1) in movieDetails.Actors"
                    :key="actorKey1"
                    class="text-center"
                  >
                    <img :src="actor.Image" class="img-fluid rounded-circle" />
                    <p class="mb-0 sName">{{ actor.Name }}</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- CREATE YOUR OWN SCREENING SLIDER -->
    <section>
      <div class="container-fluid my-4">
        <OwnScreening />
      </div>
    </section>
  </div>
</template>

<script>
import Slick from "vue-slick";
import { makeRequest } from "@/helper/internet.js";
import $ from "jquery";
//   import NowShowing from "@/components/partials/nowShowingSlider.vue";
//   import SpecialScreenings from "@/components/partials/SpecialScreeningsSlider.vue";
import OwnScreening from "@/components/partials/OwnScreeningSlider.vue";
//   import UpcomingFestivals from "@/components/partials/UpcomingMiniFestivals.vue";
import _ from "lodash";
export default {
  name: "home",
  directives: {
    // 'dragscroll': dragscroll
  },
  components: {
    Slick,
    OwnScreening
  },

  data() {
    return {
      dateTimeSlider: {
        dots: false,
        infinite: false,
        speed: 300,
        arrows: false,
        slidesToShow: 9,
        slidesToScroll: 6,
        dots: false,
        responsive: [
          {
            breakpoint: 1900,
            settings: {
              slidesToShow: 7,
              slidesToScroll: 4,
              infinite: true,
              dots: false
            }
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3.1,
              slidesToScroll: 3,
              infinite: true,
              dots: false
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 2
            }
          }
        ]
      },
      days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ],
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      movieDetails: {},
      selectedDate: "",
      MovieID: "",
      CategoryID: "",
      CinemaList: [],
      ShowDates: [],
      selectedCinemaObject: {},
      ShowTimes: [],
      ShowTimesCopy: [],
      selectedTime: "",
      CinemaTimeScheduleID: "",
      selectedShowType: "All",
      content_lang_id: null
    };
  },
  beforeMount() {
    this.MovieID = this.$route.params.movie_id;
    this.content_lang_id = this.$route.params.content_lang_id;
    this.fetchMovieDetails();
    // this.fetchCinemasList();
    this.showLoading();
  },
  watch: {
    $route(to, from) {
      this.MovieID = this.$route.params.movie_id;
      this.content_lang_id = this.$route.params.content_lang_id;
      this.fetchMovieDetails();
      // this.fetchCinemasList();
    }
  },
  methods: {
    fetchMovieDetails: function() {
      let payload = {
        movie_id: this.MovieID,
        content_lang_id: this.content_lang_id,
        category_id: 1,
        cinema_id: this.cinema_id,
        md_for_ondemand: "Y",
        guest_user_id: null,
        cust_id: 1
      };
      MainServices.GetMovieDetails(payload).then(response => {
        const { data } = response;
        if (data.status) {
          console.log("response", response);
          this.movieDetails = data.Records;
        }
      });
      makeRequest("/GetMovieDetails/", "POST", null, payload)
        .then(response => {
          const { error, res } = response;
          this.movieDetails = res.data;
          this.movieDetails.Trailer = this.movieDetails.Trailers[0].URI;
        })
        .catch(error => {
          console.log("Error", error);
        });
    },

    fetchCinemasList: function() {
      let payload = {
        MovieID: this.MovieID
      };
      makeRequest("/GetCinemaList/", "POST", null, payload)
        .then(response => {
          const { error, res } = response;
          this.CinemaList = res.data.Cinema;
          this.selectedCinemaObject = this.CinemaList[0];
          this.CinemaList.map(cinema => {
            this.fetchShowDates(cinema);
          });
        })
        .catch(error => {
          console.log("Error", error);
        });
    },
    fetchShowDates: function(cinema) {
      let payload = {
        MovieID: this.MovieID,
        CinemaID: cinema.CinemaID,
        CategoryID: this.CategoryID
      };
      makeRequest("/GetShowDate/", "POST", null, payload)
        .then(response => {
          const { error, res } = response;
          this.ShowDates = res.data.Cinema;
          this.selectedDate = this.ShowDates[0];
          this.fetchShowTimes(this.ShowDates[0].CinemaScheduleID);
          this.ShowDates.map(date => {
            let parts = date.SchTDate.split("-"),
              year = parseInt(parts[0], 10),
              month = parseInt(parts[1], 10) - 1, // NB: month is zero-based!
              day = parseInt(parts[2], 10);
            let date1 = new Date(year, month, day);
            date.day = this.days[date1.getDay()].substring(0, 3);
            date.date = date1.getDate();
            date.year = year;
            date.month = this.months[date1.getMonth()].substring(0, 3);
          });
          this.$refs.dateSlider.destroy();
          this.$nextTick(() => {
            this.$refs.dateSlider.create();
            this.$refs.dateSlider.goTo(1, true);
          });
        })
        .catch(error => {
          console.log("Error", error);
        });
    },
    fetchShowTimes: function(CinemaScheduleID) {
      let payload = {
        CategoryID: this.CategoryID,
        CinemaID: this.selectedCinemaObject.CinemaID,
        CinemaScheduleID: CinemaScheduleID,
        MovieID: this.MovieID
      };
      makeRequest("/GetShowTime/", "POST", null, payload)
        .then(response => {
          const { error, res } = response;
          this.hideLoading();

          let _times = res.data.Cinema;
          _times = _times.map(x => {
            x.CinemaTimings = tConvert(x.CinemaTimings);
            return x;
          });
          this.ShowTimes = _times;
          this.ShowTimes = _.groupBy(this.ShowTimes, "Format");
          this.ShowTimesCopy = _times;
          this.ShowTimesCopy = _.groupBy(this.ShowTimesCopy, "Format");
        })
        .catch(error => {
          console.log("Error", error);
        });
      function tConvert(time) {
        // Check correct time format and split into components
        time = time
          .toString()
          .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

        if (time.length > 1) {
          // If time format correct
          time = time.slice(1); // Remove full string match value
          time[5] = +time[0] < 12 ? " AM" : " PM"; // Set AM/PM
          time[0] = +time[0] % 12 || 12; // Adjust hours
        }
        return time.join(""); // return adjusted time or original string
      }
    },
    onSelectDate(date) {
      this.selectedDate = date;
      this.fetchShowTimes(date.CinemaScheduleID);
      this.onSelectShowType("All");
    },
    setCinemaTimeId(mTime) {
      this.selectedTime = mTime.CinemaTimings;
      this.CinemaTimeScheduleID = mTime.CinemaScheduleID;
      let showDetails = {
        CinemaName: this.selectedCinemaObject.CinemaName,
        CinemaAddress: this.selectedCinemaObject.Address,
        ShowDateTime:
          this.selectedDate.month +
          " " +
          this.selectedDate.date +
          ", " +
          this.selectedDate.year +
          " | " +
          this.selectedTime
      };
      this.secureStore.set("STD", showDetails);
    },
    onSelectShowType(showTimingsRange) {
      let obj = {};
      this.ShowTimes = this.ShowTimesCopy;
      this.selectedShowType = showTimingsRange;
      Object.values(this.ShowTimes).map((singleShow, index) => {
        let array = _.filter(singleShow, time => {
          let timing = parseInt(time.CinemaTimings.split(":")[0]);
          if (time.CinemaTimings.slice(-2) == "PM") {
            timing = timing + 12;
          }
          if (showTimingsRange == "Morning") {
            if (timing < 12) {
              return singleShow;
            }
          } else if (showTimingsRange == "Afternoon") {
            if (timing < 18 && timing >= 12) {
              return singleShow;
            }
          } else if (showTimingsRange == "Evening") {
            if (timing >= 18) {
              return singleShow;
            }
          } else if (showTimingsRange == "All") {
            return singleShow;
          }
        });
        if (showTimingsRange == "All") {
          this.ShowTimes = this.ShowTimesCopy;
        } else {
          obj["name"] = array;
          this.ShowTimes = obj;
        }
      });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/pages/regularMovies.vue